import React from "react";
import { Form, Col, Row } from 'react-bootstrap';
import { SelectInput, TextInput } from "../../../../Helpers/Inputs";
import { InputMaskFANumber, InputMaskOfficeAccount, InputMaskOfficeFA } from "../../../../Helpers/Formatters/InputMaskClientAccount";
import { getBranchOptions } from "../Helpers/Constants";

export default function ExistingClientAccountFields(props) {
    const { showDropDown, formState, register, errors, officeList, faList, msFetchClientAccount, handleValueChange } = props;
    return (
        <React.Fragment>
            {showDropDown ?
                <React.Fragment>
                    {officeList.length > 0 && <Form.Group>
                        <SelectInput
                            name="branchOptions"
                            id="branchOptions"
                            value={formState.branchOptions}
                            onChange={(e) => handleValueChange('branchOptions', e.target.value)}
                            label="How Would You Like to Proceed?"
                            selectOptions={getBranchOptions(faList)}
                            errors={errors.branchOptions}
                            inputRef={register}
                        />
                    </Form.Group>}
                    {
                        formState.branchOptions === 'INPUT' &&
                        <Form.Group>
                            <Row>
                                <Col sm={6} className='no-gutters'>
                                    <SelectInput
                                        name="officeNum"
                                        id="officeNum"
                                        value={formState.officeNum}
                                        onChange={(e) => handleValueChange('officeNum', e.target.value)}
                                        label="Office #"
                                        selectOptions={officeList}
                                        errors={errors.officeNum}
                                        inputRef={register}
                                        onBlur={() => msFetchClientAccount()}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault()
                                                e.target.blur();
                                            }
                                        }}
                                    />
                                </Col>
                                <Col sm={6} className='no-gutters pl-0'>
                                    <TextInput
                                        name="faNum"
                                        id="faNum"
                                        label="FA #"
                                        value={formState.faNum}
                                        errors={errors && errors.faNum}
                                        inputRef={register}
                                        onChange={(e) => handleValueChange('faNum', e.target.value)}
                                        InputProps={{
                                            inputComponent: InputMaskFANumber
                                        }}
                                        onBlur={() => msFetchClientAccount()}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault()
                                                e.target.blur();
                                            }
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Form.Group>
                    }
                    {
                        (formState.branchOptions === 'SELECT' || officeList.length === 0) &&
                        <Form.Group>
                            <SelectInput
                                name="officeFa"
                                id="officeFa"
                                value={formState.officeFa}
                                onChange={(e) => handleValueChange('officeFa', e.target.value)}
                                label="Office-FA #"
                                selectOptions={faList}
                                errors={errors.officeFa}
                                inputRef={register}
                                onBlur={() => msFetchClientAccount()}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault()
                                        e.target.blur();
                                    }
                                }}
                            />
                        </Form.Group>
                    }
                </React.Fragment>
                :
                <Form.Group>
                    <TextInput
                        name="officeFa"
                        id="officeFa"
                        label="Office-FA #"
                        value={formState.officeFa}
                        errors={errors && errors.officeFa}
                        inputRef={register}
                        onChange={(e) => handleValueChange('officeFa', e.target.value)}
                        InputProps={{
                            inputComponent: InputMaskOfficeFA
                        }}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault()
                                e.target.blur();
                            }
                        }}
                        onBlur={() => msFetchClientAccount()}
                    />
                </Form.Group>
            }
            {((showDropDown && (formState.branchOptions !== '' || officeList.length === 0)) || (!showDropDown)) &&
                <Form.Group>
                    <TextInput
                        name="officeAccount"
                        id="officeAccount"
                        label="Office-Account #"
                        value={formState.officeAccount}
                        errors={errors && errors.officeAccount}
                        inputRef={register}
                        onChange={(e) => handleValueChange('officeAccount', e.target.value)}
                        InputProps={{
                            inputComponent: InputMaskOfficeAccount
                        }}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                e.target.blur();
                            }
                        }}
                        onBlur={() => msFetchClientAccount()}
                    />
                </Form.Group>
            }
        </React.Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/RetrieveAccount/SubComponents/ExistingClientAccountFields.js